import { useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { GraphContent} from './PieGraph.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';

import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  ArcElement, // Important for pie charts
} from 'chart.js';
import { Pie } from 'react-chartjs-2';

interface IProps { data?: any }

ChartJS.register(ArcElement, Tooltip, Legend );

export const PieGraph = (props: IProps) => {
  const {client } = useStore();  

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      }
    }
  }
  
  return (<>
      <GraphContent>
        {props.data?<Pie data={props.data} options={options} />:null}
      </GraphContent>
  </>);
};

export default PieGraph;
